module.exports = __webpack_public_path__ + "img/img2.0e62c33e.svg";